import { Div } from 'MoshtixShared/component-element';
import { Section } from 'MoshtixShared/component-section';
import { theme } from 'MoshtixShared/helper-theme-ticket-distro';
import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { withTheme } from 'theming';
import styles from './styles';

const EventHeaderSkeletonNoTheme: FC = () => (
  <Div css={styles.backgroundCss({ theme })}>
    <Section maxWidth={630}>
      <Skeleton height={41} />
      <Skeleton />
      <Div css={styles.flexContainerCss}>
        <Skeleton height={90} width={90} />
        <Div css={styles.marginLeftPx(10)} />
        <Skeleton height={41} width={200} />
      </Div>
      <Div css={styles.eventDetailsWrapperCss}>
        <Div css={styles.eventDetailsContainerCss}>
          <Skeleton circle height={38} width={38} />
          <Div css={styles.eventDetailsCss}>
            <Skeleton count={3} />
          </Div>
        </Div>
        <Div css={styles.marginLeftPx(20)} />
        <Div css={styles.eventDetailsContainerCss}>
          <Skeleton circle height={38} width={38} />
          <Div css={styles.eventDetailsCss}>
            <Skeleton count={3} />
          </Div>
        </Div>
      </Div>
    </Section>
  </Div>
);

const TicketListSkeletonNoTheme = () => (
  <Div css={styles.ticketListWrapperCss}>
    <Skeleton height="100px" />
    <br />
    <br />
    <Skeleton height="50px" width="200px" />
    <br />
    <Skeleton height="30px" width="400px" />
  </Div>
);

export const EventHeaderSkeleton = withTheme(EventHeaderSkeletonNoTheme);
export const TicketListSkeleton = withTheme(TicketListSkeletonNoTheme);
